import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';


const Footer = ({ intl }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerTop">

                <div className='logoWhiteDiv'>
                    <img src='../logo_white.png' alt='Logo White' className='logoWhite' />
                </div>

                <div>
                    <List className="footerList">
                        <div role="listitem" className="item footerName">
                            <p className="item">
                                <FormattedMessage
                                    id="Footer-Name"
                                    defaultMessage="Allianz Posaunenchor Langnau"
                                />
                            </p>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-phone-line"></i>
                            <a className="item" href="tel:079 640 06 81">
                                <FormattedMessage
                                    id='Footer-Telefon'
                                    defaultMessage="079 640 06 81"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-mail-line"></i>
                            <a className="item" href="mailto:info@posaunenchorlangnau.ch">
                                <FormattedMessage
                                    id='Footer-Email'
                                    defaultMessage="info@posaunenchorlangnau.ch"
                                />
                            </a>
                        </div>
                        <br />
                        <div role="listitem" className="item">
                            <a className="item" href="https://www.facebook.com/profile.php?id=100063511313676" target='_blank'>
                                <i className='ri-facebook-circle-fill' style={{ fontSize: "25pt" }}></i>
                            </a>
                            <a className="item" href="https://www.instagram.com/posaunenchor.langnau/" target='_blank'>
                                <i className='ri-instagram-line' style={{ fontSize: "25pt" }}></i>
                            </a>
                        </div>
                    </List>
                </div>
            </div>
            <hr />
            <div className='footerBottom'>
                <div>
                    <List className="footerList">
                        <div role="listitem" className="item">
                            <a className="item" href="./impressum">
                                <FormattedMessage
                                    id='Footer-Imprint'
                                    defaultMessage="Impressum"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <a className="item" href="./datenschutz">
                                <FormattedMessage
                                    id='Footer-Privacy'
                                    defaultMessage="Datenschutzerklärung"
                                />
                            </a>
                        </div>
                        <div role="listitem" className="item">
                            <i className="ri-copyright-line"></i>
                            {currentYear}&nbsp;
                            <FormattedMessage
                                id='Footer-Copyright'
                                defaultMessage="Allianz Posaunenchor Langnau"
                            />
                        </div>
                    </List>
                </div>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);